import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ContenServiceService} from '../api/conten-service.service';
import {fromEvent, Observable, Subscription} from 'rxjs';
import {FromEventTarget} from 'rxjs/internal/observable/fromEvent';
import {element} from 'protractor';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit , AfterViewInit , OnDestroy{
  @ViewChild('home', {static: true}) homeElement: ElementRef;
  @ViewChild('about' , {static: true}) aboutElement: ElementRef;
  @ViewChild('services', {static: true}) serviceElement: ElementRef;
  @ViewChild('container', {static: true}) containerElement: ElementRef;
  @ViewChild('contact', {static: true}) contactElement: ElementRef;
  public homeOffset: number = null;
  public aboutOffset: number = null;
  public serviceOffset: number = null;
  public contactOffset: number = null;
  eventSubscription: Subscription;
  scroolSource = null ;
  ngAfterViewInit() {
    this.homeOffset = this.homeElement.nativeElement.offsetTop;
    this.aboutOffset = this.aboutElement.nativeElement.offsetTop;
    this.serviceOffset = this.serviceElement.nativeElement.offsetTop;
    this.contactOffset = this.contactElement.nativeElement.offsetTop;
    this.eventSubscription = fromEvent(window, 'scroll').subscribe(
      e => this.checkOffsetTop(e)
    );

  }
  constructor(private contentService: ContenServiceService) { }

  ngOnInit() {
    this.eventSubscription = this.contentService.currentActive.subscribe(
      link => console.log(link)
    );
    this.eventSubscription = this.contentService.LinkClick.subscribe(
      link => this.scrollToelement(link)
    )
    ;
  }
  ngOnDestroy(): void {
    this.eventSubscription.unsubscribe(
    );
  }

  checkOffsetTop(e) {
    console.log();
    if (window.pageYOffset >= this.homeOffset && window.pageYOffset < this.aboutOffset) {
      this.contentService.currentActive.next('home');
    } else if (window.pageYOffset >= this.aboutOffset && window.pageYOffset < this.serviceOffset) {
      this.contentService.currentActive.next('about');
    } else if (window.pageYOffset >= this.serviceOffset && window.pageYOffset < this.contactOffset) {
      this.contentService.currentActive.next('services');
    }
    else if (window.pageYOffset >= this.contactOffset) {
      this.contentService.currentActive.next('contact');
    }
  }
  scrollToelement(el: string) {
    if (el === 'home') {
      this.homeElement.nativeElement.scrollIntoView({behavior: 'smooth'});
    } else if (el === 'about') {
        this.aboutElement.nativeElement.scrollIntoView({behavior: 'smooth'});
      } else if (el === 'services') {
      this.serviceElement.nativeElement.scrollIntoView({behavior: 'smooth'});
    } else if (el === 'contact') {
      this.contactElement.nativeElement.scrollIntoView({behavior: 'smooth'});
    }
  }
}
